import { Container } from 'pixi.js';
import type { ResourceMap } from '../../../app/resources/types';
import { CollectEventRewardNodeLayout } from '../../../../layouts/collectEvent/CollectEventRewardNodeLayout';
import { applyLayoutState } from '../../../libs/layouts/populateLayouts/applyLayoutState';
import { createInventoryItemViews } from '../../../views/InventoryItemAmountView';

export class CollectionEventNodeView extends Container {
  private readonly layout = new CollectEventRewardNodeLayout();

  constructor(nodeNumber: number, resourceMap: ResourceMap, unlocked: boolean) {
    super();

    const { root, levelText, rewardSlot, nodePath } = this.layout;

    levelText.text = nodeNumber === Infinity ? '∞' : nodeNumber;

    root.props({
      parent: this,
    });

    nodePath.visible = nodeNumber > 1;

    createInventoryItemViews(resourceMap).forEach((view) => {
      view.props({
        parent: rewardSlot,
        scale: 1.3,
      });
    });

    if (unlocked) {
      applyLayoutState(this.layout, 'unlocked');
    }
  }
}
